import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/auth';

// Replace this with your own config details
export const config = {
  apiKey: "AIzaSyDgqbPWmzNrEwxpXue_BaVD1WsxNL3Gc5A",
  authDomain: "welfarex-v2.firebaseapp.com",
  projectId: "welfarex-v2",
  storageBucket: "welfarex-v2.firebasestorage.app",
  messagingSenderId: "596380714914",
  appId: "1:596380714914:web:cf77245b00dcdcd8f954fb",
  measurementId: "G-1D4L7GY7TJ"
};
firebase.initializeApp(config);
firebase.firestore().settings({ experimentalAutoDetectLongPolling: true }); 

export default firebase;